// Canonical Coachify category taxonomy -- Sports / Health-Wellness / Gaming
// / Hobbies / Other, with real subcategories. Mirrored from
// packages/shared/src/coachify-categories.ts (discovery.coachifyusa.com's
// own source of truth), same pattern that file itself uses ("mirrored from
// the live marketplace") -- two separate repos, no shared import path, so
// this is a deliberate, matching copy rather than a build-time link.
//
// This is ONLY a fallback: it's used exclusively when Sharetribe Console's
// own hosted `categories` asset comes back empty (see its one call site in
// configHelpers.js). If Console has real categories configured, those win,
// unchanged -- this never overrides live admin configuration, it only
// fills the gap when there's nothing there. Existing sessions' stored
// mainCategory/subCategory values are untouched either way; this only
// affects what shows up in category pickers/filters going forward.
//
// Shape matches Sharetribe's own hosted-category schema exactly
// (validateCategoryConfig in configHelpers.js): { name, id, subcategories }.
const group = (id, name, subs) => ({
  id,
  name,
  subcategories: subs.map((sub) => ({ id: slugify(sub), name: sub, subcategories: [] })),
});

function slugify(s) {
  return s
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}

export const COACHIFY_CATEGORIES_FALLBACK = [
  group('sports', 'Sports', [
    'Baseball', 'Basketball', 'Biking/Cycling', 'Billiards', 'Bowling', 'Cheerleading',
    'Cornhole', 'Cricket', 'Cross Fit', 'Dance', 'Disc Golf', 'Dodgeball', 'Football',
    'Golf', 'Gymnastics', 'Hyrox', 'Kickball', 'Lacrosse', 'Martial Arts', 'Motosports',
    'Padel', 'Pickleball', 'Ping Pong', 'Racquetball', 'Rock Climbing', 'Rugby', 'Running',
    'Skateboard/Rollerblade', 'Skiing', 'Snowboard', 'Soccer', 'Softball', 'Swimming',
    'Tennis', 'Track & Field', 'Ultimate Frisbee', 'Volleyball', 'Water Sports',
  ]),
  group('health-wellness', 'Health/Wellness', [
    'Mobility', 'Personal Training', 'Pilates', 'Spin', 'Strength Training', 'Yoga', 'Zumba',
  ]),
  group('gaming', 'Gaming', ['Board Games', 'Chess/Checkers', 'Console', 'PC', 'VR']),
  group('hobbies', 'Hobbies', [
    'Arts & Crafts', 'Cooking', 'Dance', 'Disc Jockey', 'Hiking', 'Music', 'Photography',
    'Piano Lessons', 'Social Media', 'Voice Lessons',
  ]),
  group('other', 'Other', [
    'Ai', 'Business', 'Coding', 'E-Courses', 'Trade Skills', 'Tutoring', 'Life',
    'Miscellaneous', 'Nutrition', 'Youtube',
  ]),
];
